module.exports = __webpack_public_path__ + "static/img/programme_jingyun.bf5b537.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/programme_jingyun.jpg
// module id = WIng
// module chunks = 0